import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LucideUsers } from '@lucide/angular';
import { AdminMemberTableComponent } from '../admin-member-table/admin-member-table.component';

@Component({
  selector: 'ptl-v3-admin-member-table',
  templateUrl: './v3-admin-member-table.component.html',
  styleUrls: ['./v3-admin-member-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class V3AdminMemberTableComponent extends AdminMemberTableComponent {
  protected readonly LucideUsers = LucideUsers;
}
